import clsx from "clsx";
import React from "react";
import { isEmpty } from "lodash";
import { FieldErrors } from "react-hook-form";

interface FormComponentProps {
	id: string;
	name: string;
	label?: string;
	legend?: string;
	required?: boolean;
	errors?: FieldErrors;
	classes?: string;
	children: React.ReactNode;
}

export function FormComponent({
	id,
	name,
	label,
	legend,
	required,
	errors,
	classes,
	children,
}: FormComponentProps) {
	let errorMessage;

	if (!isEmpty(errors) && errors[name]) {
		const error = errors[name];
		switch (error.type) {
			case "buy":
				errorMessage = "Please select what you would like to buy.";
				break;

			case "match":
				errorMessage = "E-mail addresses do not match.";
				break;

			case "pattern":
				errorMessage = "Please enter a valid email address.";
				break;

			case "segment":
				errorMessage =
					"Please select the industry you are interested in.";
				break;

			case "custom":
				errorMessage = error.message;
				break;

			default:
				errorMessage = "This field is required.";
		}
	}

	return (
		<fieldset
			className={clsx("form-group", classes, {
				error: !isEmpty(errors) && errors[name],
				required,
			})}
		>
			{label && <label htmlFor={id}>{label}</label>}
			{legend && <legend>{legend}</legend>}

			{errorMessage && (
				<span className="error-text" role="alert">
					{String(errorMessage)}
				</span>
			)}

			{children}
		</fieldset>
	);
}
